import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "@/components/site/Page";
import { CookiePolicyContent } from "@/components/site/PolicyCookieSection";
import { getCookiePolicyContent } from "@/lib/cookie-policy.functions";
import { absoluteUrl, ogImage, seoLinks } from "@/lib/seo";

const title = "Política de cookies | Swedish International School";
const description =
  "Qué cookies y almacenamiento utiliza sweintschool.com, para qué, durante cuánto tiempo y cómo cambiar su elección.";

export const Route = createFileRoute("/es/politica-de-cookies")({
  loader: () => getCookiePolicyContent({ data: { locale: "es" } }),
  errorComponent: () => <PolicyLoadError message="No se pudo cargar la política de cookies." />,
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/es/politica-de-cookies") },
      { name: "twitter:card", content: "summary" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/politica-de-cookies"),
  }),
  component: CookiePolicyPage,
});

function CookiePolicyPage() {
  const policy = Route.useLoaderData();
  return (
    <>
      <PageHero eyebrow="Legal" title="Política de cookies" intro="Qué cookies usamos, para qué y cómo cambiar su elección." />
      <PolicyBody>
        <CookiePolicyContent locale="es" body={policy.body} />
      </PolicyBody>
      <div className="h-20" />
    </>
  );
}

function PolicyLoadError({ message }: { message: string }) {
  return <main className="mx-auto max-w-3xl px-4 py-24"><p role="alert">{message}</p></main>;
}
